import { Component, inject, input } from "@angular/core"
import { faCloudMoon, faMoon, faSun, } from "@fortawesome/free-solid-svg-icons"
import { UiThemeModeSwitcherComponent, UiThemeService } from "ui-theme"

@Component({
  imports: [
    UiThemeModeSwitcherComponent,
  ],
  providers: [],
  standalone: true,
  template: `
    <lib-ui-theme-mode-switcher 
      buttonClasses="btn-ghost text-2xl px-2"
      [visible]="visible()"
    />
  `,
  selector: "e2e-theme",
})
export class ThemeComponent {
  private themeService = inject(UiThemeService)

  visible = input(true)

  constructor() {
    this.themeService.setThemeNames(["auto", "redline_light", "redline_dark"])
    this.themeService.setThemeIcons([faCloudMoon, faSun, faMoon])
  }

}
